<mat-grid-list class="header-grid" cols="1">
    <div class="mobile-header-container" *ngIf="isMobile">
        <div class="header-menu-logo">
            <div class="hamburger-menu" #hamburgerMenu (click)="openMenu()">
                <div class="menu-icon"></div>
                <div class="menu-icon"></div>
                <div class="menu-icon"></div>
            </div>
            <div class="logo-container">
                <div class="logo-frame" [ngClass]="{'imp-logo-frame': showBanner}">
                    <img src="../../../assets/images/header-logo.svg">
                </div>
                <div class="logo-frame-2" [ngClass]="{'imp-logo-frame-2': showBanner}">
                    <img src="../../../assets/images/header-logo.svg">
                </div>
            </div>
        </div>
        <!-- <div class="release-banner">
            UPCOMING CHANGES: On Oct 7, your hole location sheets will now feature your club's mobile access QR code, replacing the right side logo. This can be updated at anytime within the Format settings.
        </div> -->
        <div class="geoez-badge-item" (click)="openGeoezBadge()">
            <ng-container *ngTemplateOutlet="geoezAppBadge"></ng-container>
        </div>
        <div (click)="toggleProfileMenu()" #porfileIcon>
            <mat-icon class="profile-icon">account_circle</mat-icon>
        </div>
    </div>
    <div *ngIf="isMobile && profileMenuOpen" #profileMenu class="profile-menu">
        <ul>
            <li *ngIf="superAdmin && !impersonate" (click)="openImpersonateDialog(); toggleProfileMenu()">IMPERSONATE</li>
            <li *ngIf="superAdmin && impersonate" (click)="onImpersonateExit(); toggleProfileMenu()">EXIT IMPERSONATE</li>
            <hr *ngIf="superAdmin"/>
            <li class="show-alert" [routerLink]="['/alerts']" (click)="toggleProfileMenu()">
                <div id="alert-models"></div>
                <span>ALERTS</span>
                <img width="17px" height="18px" src="../../../../assets/images/notification.svg">
            </li>
            <hr/>
            <li (click)="navigateToTrainingLibrary()" id='resourceButtonMobile'>TRAINING LIBRARY</li>
            <hr/>
            <li (click)="showResource(); toggleProfileMenu()" id='resourceButtonMobile'>RESOURCES</li>
            <hr/>
            <li [routerLink]="['/myaccount']" (click)="toggleProfileMenu()">MY ACCOUNT</li>
            <hr/>
            <li (click)="navigateToHelpCenter()" class="help-link">HELP</li>
            <hr/>
            <li (click)="logOut(); toggleProfileMenu()">LOG OUT</li>
        </ul>
    </div>
    <div class="header-container" *ngIf="!isMobile">
        <div class="header-logo-container">
            <div class="logo-frame" [ngClass]="{'imp-logo-frame': showBanner}">
                <img src="../../../assets/images/header-logo.svg">
            </div>
            <div class="logo-frame-2" [ngClass]="{'imp-logo-frame-2': showBanner}">
                <img src="../../../assets/images/header-logo.svg">
            </div>
            <div *ngIf="remainingTrialDays>0 && subscriptionType=='free'" class="trial-end-text">FREE TRIAL ENDS IN {{remainingTrialDays}} {{remainingTrialDays>1?'DAYS':'DAY'}}</div>
            <div *ngIf="subscriptionType!='lite' && subscriptionType!='premium' && clientId" class="upgrade-button">UPGRADE</div>
        </div>
        <!-- <div class="release-banner">
            UPCOMING CHANGES: On Oct 7, your hole location sheets will now feature your club's mobile access QR code, replacing the right side logo. This can be updated at anytime within the Format settings.
        </div> -->
        <div class="header-nav" [ngClass]="{'imp-header-nav': showBanner}">
            <ul>
                <li class="geoez-badge-item" (click)="openGeoezBadge()">
                    <ng-container *ngTemplateOutlet="geoezAppBadge"></ng-container>
                </li>
                <li *ngIf="superAdmin && !impersonate" (click)="openImpersonateDialog()">IMPERSONATE</li>
                <li *ngIf="superAdmin && impersonate" (click)="onImpersonateExit()">EXIT IMPERSONATE</li>
                <li class="show-alert">
                    <div id="alert-models"></div>
                    <img [routerLink]="['/alerts']" width="17px" height="18px" src="../../../../assets/images/notification.svg">
                </li>
                <li (click)="navigateToTrainingLibrary()" id='resourceButton'>TRAINING LIBRARY</li>
                <li (click)="showResource()" id='resourceButton'>RESOURCES</li>
                <li [routerLink]="['/myaccount']">MY ACCOUNT</li>
                <li (click)="navigateToHelpCenter()" class="help-link">HELP</li>
                <li (click)="logOut()">LOG OUT</li>
            </ul>
        </div>
    </div>
    <app-resources 
        id='resource' *ngIf="showNotification" (printMemberAccessFlyer)="enableMemberAccessFlyer($event)" 
        (closeNotification)="hideNotification()" [isSuperAdmin]="superAdminView" (openMemberPinsheetPage)="openMemberPinsheetPage($event)"
        [memberFlyerQRCodeURL]="memberFlyerQRCodeURL" [userRightId]="userRightId">
    </app-resources>
</mat-grid-list>

<ng-template #geoezAppBadge let-inDialog="inDialog">
    <div class="geoez-app-badge">
        <button *ngIf="inDialog" class="close" mat-button (click)="closeGeoezBadge()">X</button>
        <div class="geoez-qr" *ngIf="inDialog">
            <img src="../../../../assets/images/geoez-qr-apple.png" alt="GeoEZ app on the App Store QR code">
            <span>Apple</span>
        </div>
        <div class="geoez-text">
            <img class="geoez-logo" src="../../../../assets/images/geoez-logo.png" alt="GEOEZ">
            <span class="geoez-tagline">Explore the LIVE DEMO!</span>
        </div>
        <div class="geoez-qr" *ngIf="inDialog">
            <img src="../../../../assets/images/geoez-qr-android.png" alt="GeoEZ app on Google Play QR code">
            <span>Android</span>
        </div>
    </div>
</ng-template>

<ng-template #geoezBadgeDialogRef>
    <div class="geoez-badge-dialog">
        <ng-container *ngTemplateOutlet="geoezAppBadge; context: { inDialog: true }"></ng-container>
    </div>
</ng-template>

<ng-template #impersonateDialogRef class="custom-modal">
    <button class="close" mat-button (click)="onImpersonateDialogClose()">X</button>
    <div class="client-dropdown">
        <p>CLIENT</p>
        <app-impersonate-dropdown class="dropdown_1"
            [label]="clientLabel" (selectedId)="onSelectClientId($event)"
            (setSelected)="setSelectedClientName($event)"  [page]="'impersonateDialog'"
            [dropdownList]="clientsData" [isMobile]="isMobile">
        </app-impersonate-dropdown>
    </div>
    <div class="user-dropdown">
        <p>USER</p>
        <app-dropdown [label]="userLabel || 'SELECT USER'"
            [Isshow]="false" (setSelected)="setUserSelectedValue($event)"
            (selectedId)="onUserSelection($event)" [dropdownArr]="userList"
            [page]="'impersonateDialog'" [userRight]="userRight" [isFont]="isMobile || !desktop">
        </app-dropdown>
    </div>
    <div class="impersonate-button">
        <button class="theme-button" (click)="onImpersonate()" [disabled]="userLabel=='SELECT USER'" 
            [ngClass]="{'disabled': userLabel=='SELECT USER'}">SUBMIT
        </button>
    </div>
</ng-template>

<ng-template #notificationDialogRef class="custom-modal">
    <button class="close" mat-button (click)="onNotificationDialogueClose()">X</button>
        <h3 class="notification-header">NOTIFICATION</h3>
        <div class="notification-subject-content">
            <div class="notification-subheader">
                <h3 class="notification-header">Subject: {{alertSubject.Subject}}</h3>
                <h3 class="notification-header">{{alertDateFormat}}</h3>
            </div>
            <div [innerHTML]="alertSubject.Value " class="notification-content">
            </div>
        </div>
</ng-template>

<div *ngIf="enablePrint" class="print-container flyer-print-area">
    <img src="../../../../assets/images/Member Pinsheet Flyer.png" id="instructions-bg-image" (load) ="onLoadFlyer()" (error)="onFlyerLoadingError($event)" />
    <qrcode id="member-url-qr-code" [qrdata]="memberFlyerQRCodeURL" [width]="180" [margin]="2"></qrcode>
    <!-- <a id="member-page-url" href="{{memberFlyerQRCodeURL}}">{{memberFlyerQRCodeURL}}</a> -->
</div>